import { defineStore } from "pinia";
import { CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";
import { Auth } from "aws-amplify";

interface AuthState {
  userGroup: string;
  userInfo: CognitoUser | null;
  accessToken: string;
}

export const useAuth = defineStore("auth", {
  state: (): AuthState => ({
    userGroup: "test",
    userInfo: null,
    accessToken: localStorage.getItem("accessToken") || "",
  }),
  getters: {
    isLoggedIn(): boolean {
      return !!this.userInfo;
    },
    // getAccessToken(): string {
    //   return this.accessToken;
    // },
  },
  actions: {
    async getCurrentUserInfo() {
      const userInfo = await Auth.currentUserInfo();
      let accessToken = "";
      if (userInfo) {
        accessToken = await Auth.currentSession().then(
          (r: CognitoUserSession) => {
            return r.getAccessToken().getJwtToken();
          }
        );
      }
      Object.assign(this, {
        userInfo,
        accessToken,
      });
      return Promise.resolve();
    },
  },
});
